import React from "react";
import TableRow from "./partials/TableRow";
import Tables from "../../../../../components/organisms/Tables";
import { headersData } from "./api/headerData";
import { selectAverageFruits } from "../../../../../features/averageFruitSlice";
import { useSelector } from "react-redux";

const ListAverageFruit = ({ isLoading, onDelete, onUpdate }) => {
	const data = useSelector(selectAverageFruits);

	return (
		<div className="mx-16 rounded-8 rounded-b-[0px] border border-gray-50 bg-white">
			<Tables
				isLoading={isLoading}
				headers={headersData}
				rows={data || []}
				rowContent={(e) => (
					<TableRow
						data={e}
						onDelete={onDelete}
						onUpdate={onUpdate}
					/>
				)}
			/>
		</div>
	);
};

export default ListAverageFruit;
